module.exports = __webpack_public_path__ + "static/ContentChange-9fe83e2c6f55400c57914516acfa13a4.png";